// isFavoriteOfPlayer.js
import { db } from "@/firebase/config";
import { doc, getDoc } from "firebase/firestore";

const isFavoriteOfPlayer = async (hId, pId) => {
  try {
    // Composite key: hostId + playerId (no joiner)
    const docId = `${hId}${pId}`;
    const ref = doc(db, "playerFavorites", docId);
    const snap = await getDoc(ref);

    if (!snap.exists()) return false;

    const data = snap.data();
    return data?.favorite === true;
  } catch (err) {
    console.error("isFavoriteOfPlayer error:", err);
    return false;
  }
};

export default isFavoriteOfPlayer;
